import styled from 'styled-components';
import { Heading } from '@hvccc/component-library';

export default styled(Heading)``;
